/** Municipality user management API (Sprint 2). Tenant resolved server-side. */
import apiClient from '@/services/api/client';

export const listUsers = async (params = {}) => {
        const res = await apiClient.get('/v1/admin/users', { params });
        return { items: res.data, total: Number(res.headers['x-total-count'] ?? res.data.length) };
};
export const createUser = async (body) => (await apiClient.post('/v1/admin/users', body)).data;
export const updateUser = async (id, body) => (await apiClient.put(`/v1/admin/users/${id}`, body)).data;
export const suspendUser = async (id) => (await apiClient.post(`/v1/admin/users/${id}/suspend`)).data;
export const reactivateUser = async (id) => (await apiClient.post(`/v1/admin/users/${id}/reactivate`)).data;
export const resetUserPassword = async (id) => (await apiClient.post(`/v1/admin/users/${id}/reset-password`)).data;
